import { Component, inject, model, signal } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { RoleService } from '../../../role/role.service';
import { CommonPipesModule } from '../../../shared/pipes/common-pipes.module';
import { AsyncPipe, CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-admin-invoices',
  templateUrl: './admin-invoices.component.html',
  styleUrls: ['./admin-invoices.component.scss', '../admin-main.common.scss'],
  imports: [
    AsyncPipe,
    CommonModule,
    CommonPipesModule,
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    SharedModule,
  ],
})
export class AdminInvoicesComponent {

  public invoiceType = model<string | undefined>('Invoice::Purchase');

  public loading = signal<boolean>(false);

  public TYPES = [
    'Invoice::Purchase',
    'Invoice::Sale',
  ]

  public readonly roleService = inject(RoleService);


  onTypeSelected(): void {
    this.loading.set(true);
    setTimeout(() => {
      this.loading.set(false);
    }, 50);
  }

}
